<script lang="ts">
    import { Button } from 'sveltestrap'
    import Card from "../../Core/Card.svelte";
    import { CustomStateButtons, CustomStateButtonsMessage } from '../../../utils/Constant/Constant';
</script>
  
<Card headerTitle={CustomStateButtons} cardHeaderprops="pb-0" cardBodyprops="btn-showcase">
    <div slot="customheader" >
      <span>{@html CustomStateButtonsMessage}</span>
    </div>
    <div slot="contentbody">
        <Button color="primary" class="btn-square">Link</Button>
        <Button color="secondary" class="btn-square" >Input</Button>
        <Button color="success" class="btn-square" >Submit</Button>
        <Button color="info" class="btn-square">Button</Button>
      </div>
</Card>
  